import { mergeClassName as e } from "../../utils/data.js";
import { isColorLexicalName as t, isColorName as n, normalizeColorName as r } from "../../utils/colors.js";
import i from "./Card.module.js";
import { Typography as a } from "../Typography/Typography.js";
import { useMemo as o } from "react";
import { Fragment as s, jsx as c, jsxs as l } from "react/jsx-runtime";
//#region lib/components/Card/Card.tsx
function u(e) {
	return e ? t(e) || n(e) : !1;
}
function d(e) {
	return u(e) ? `var(--ag-${r(e)}-2)` : e;
}
function f(e) {
	return u(e) ? `var(--ag-${r(e)}-5)` : e;
}
function p(e, t) {
	if (!u(e)) return e;
	let n = r(e);
	return t ? `var(--ag-${n}-7)` : `var(--ag-${n}-5)`;
}
function m({ children: e }) {
	return /* @__PURE__ */ c(a, {
		alignItems: "center",
		variant: "heading-small",
		className: i.title,
		children: e
	});
}
function h({ children: t, className: n, noBorder: r = !1, title: a, divideTitle: u = !1, isClickable: h = !1, style: g, backgroundColor: _, padding: v = 4, titlePadding: y = 4, radius: b = 3, spacing: x = 4, ...S }) {
	let C = o(() => e(i.card, r ? void 0 : i.bordered, h ? i.clickable : void 0, n), [
		r,
		h,
		n
	]), w = u && a, T = o(() => ({
		padding: w ? 0 : `var(--ag-spacing-${String(v)})`,
		borderRadius: `var(--ag-radius-${String(b)})`,
		gap: w ? 0 : `var(--ag-spacing-${String(x)})`,
		"--card-background-color": d(_),
		"--card-border-color": f(_),
		"--card-hover-border-color": p(_, h),
		...g
	}), [
		w,
		v,
		b,
		x,
		_,
		h,
		g
	]);
	return /* @__PURE__ */ c("div", {
		...S,
		title: typeof a == "string" ? a : void 0,
		className: C,
		style: T,
		children: w ? /* @__PURE__ */ l(s, { children: [
			/* @__PURE__ */ c("div", {
				className: i.titleSection,
				style: { padding: `var(--ag-spacing-${String(y)}) var(--ag-spacing-${String(v)})` },
				children: /* @__PURE__ */ c(m, { children: a })
			}),
			/* @__PURE__ */ c("div", { className: i.divider }),
			/* @__PURE__ */ c("div", {
				className: i.cardBody,
				style: {
					padding: `var(--ag-spacing-${String(v)})`,
					gap: `var(--ag-spacing-${String(x)})`
				},
				children: t
			})
		] }) : /* @__PURE__ */ l(s, { children: [a && /* @__PURE__ */ c(m, { children: a }), t] })
	});
}
//#endregion
export { h as Card };
